import React from "react";
import PropTypes from "prop-types";
import Headline from "~/assets/js/components/Typography/Headline";

const HomepageHeading = ({ title, metaTitle, alignment }) => {
    return (
        <div className="homepage-heading">
            <Headline
                size={5}
                className="homepage-heading_meta-title"
                style={{ textAlign: alignment }}
            >
                {metaTitle}
            </Headline>
            <Headline
                size={3}
                className="homepage-heading_title"
                style={{ textAlign: alignment }}
            >
                {title}
            </Headline>
        </div>
    );
};

HomepageHeading.propTypes = {
    title: PropTypes.string.isRequired,
    metaTitle: PropTypes.string.isRequired,
    alignment: PropTypes.string,
};

HomepageHeading.defaultProps = {
    alignment: "left",
};

export default HomepageHeading;
